import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5afd4ba2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "LogicalQuestionEditorContainer"
};
const _hoisted_2 = {
  class: "mr16"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "flex items-center justify-center mt16 wd100",
  style: {
    "height": "400px"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-center mt16 wd100",
  style: {
    "height": "400px"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请先添加题目", -1));
const _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_LogicalQuestionSelector = _resolveComponent("LogicalQuestionSelector");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.totalQuestionSize, qi => {
    return _openBlock(), _createBlock(_component_el_row, {
      key: `lg_${qi}`,
      class: "wbg mt12",
      style: {
        "border": "#1388ff 1px dashed"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col flex items-center justify-center pd12"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "ft14"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString(qi) + "题 ", 1)]),
          _: 2
        }, 1024), $data.questions.length >= qi && $data.questions[qi - 1] ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($data.questions[qi - 1].questionField), (img, imgIndex) => {
          return _openBlock(), _createElementBlock("img", {
            key: `img_${qi}_${imgIndex}`,
            style: {
              "max-width": "100%"
            },
            src: img
          }, null, 8, _hoisted_3);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($data.questions[qi - 1].optionField), (img, imgIndex) => {
          return _openBlock(), _createElementBlock("img", {
            key: `img_op_${qi}_${imgIndex}`,
            style: {
              "max-width": "100%"
            },
            src: img
          }, null, 8, _hoisted_4);
        }), 128))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          onClick: $event => $options.toAdd(qi - 1)
        }, {
          default: _withCtx(() => [_createTextVNode("添加试题")]),
          _: 2
        }, 1032, ["onClick"])]))]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 12,
        class: "flex flex-col colCenter ft14"
      }, {
        default: _withCtx(() => [$data.questions.length >= qi && $data.questions[qi - 1] ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_row, {
          class: "flex items-center justify-center wd100 pd12"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 4,
            class: "flex items-center justify-center"
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 16,
            class: "flex items-center justify-center"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, "答案：" + _toDisplayString($data.questions[qi - 1].rightAnswer), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 4,
            class: "flex justify-end items-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => $options.toAdd(qi - 1)
            }, {
              default: _withCtx(() => [_createTextVNode("换题")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($data.questions[qi - 1].analysisFiled), (img, imgIndex) => {
          return _openBlock(), _createElementBlock("img", {
            key: `img_aw_${qi}_${imgIndex}`,
            style: {
              "max-width": "100%"
            },
            src: img
          }, null, 8, _hoisted_7);
        }), 128))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024);
  }), 128))]), _createVNode(_component_el_drawer, {
    modelValue: $data.drawer,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.drawer = $event),
    title: "选择题目",
    size: "1000px",
    "with-header": false
  }, {
    default: _withCtx(() => [_createVNode(_component_LogicalQuestionSelector, {
      onConfirm: $options.onSelected
    }, null, 8, ["onConfirm"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}